import { fullDateTime, relativeTime } from "@/lib/format";

/**
 * A moment in time: relative text ("3 hours ago") with the exact date and time in the tooltip, as a
 * real <time>. `absolute` shows the exact time instead (audit detail). Not live-updating.
 */
export function RelativeTime({
  value,
  absolute,
  className,
}: {
  value: string;
  absolute?: boolean;
  className?: string;
}) {
  const full = fullDateTime(value);
  return (
    <time dateTime={value} title={absolute ? undefined : full} className={className}>
      {absolute ? full : relativeTime(value)}
    </time>
  );
}
